import { Subject } from 'rxjs';
import { SortMeta } from '../../common';
import { Injectable } from '@angular/core';

@Injectable()
export class TableService {
  sortSource = new Subject<SortMeta | SortMeta[]>();
  selectionSource = new Subject();
  contextMenuSource = new Subject<any>();
  valueSource = new Subject<any>();
  totalRecordsSource = new Subject<any>();
  columnsSource = new Subject();

  sortSource$ = this.sortSource.asObservable();
  selectionSource$ = this.selectionSource.asObservable();
  contextMenuSource$ = this.contextMenuSource.asObservable();
  valueSource$ = this.valueSource.asObservable();
  totalRecordsSource$ = this.totalRecordsSource.asObservable();
  columnsSource$ = this.columnsSource.asObservable();

  onSort(sortMeta: SortMeta | SortMeta[]) {
    this.sortSource.next(sortMeta);
  }

  onSelectionChange() {
    this.selectionSource.next(null);
  }

  onContextMenu(data: any) {
    this.contextMenuSource.next(data);
  }

  onValueChange(value: any) {
    this.valueSource.next(value);
  }

  onTotalRecordsChange(value: number) {
    this.totalRecordsSource.next(value);
  }

  onColumnsChange(columns: any[]) {
    this.columnsSource.next(columns);
  }
}
